import React from 'react';
import ReactDOM from 'react-dom/client';
import TruckPilot from './TruckPilot';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<TruckPilot />);
